export const enum WidgetEventName {
    /** Used to capture an event from outside */
    ChatUnreadCountUpdated = 'chat-unread-count-updated',
    ChatStateChanged = 'chat-state-changed',
    ChatAudioCaptureStateChange = 'chat-audio-capture-state-change',
}
